/// <amd-module name="Environments/EnvironmentsCommon/MessagesActions" />
import * as React from "react";

import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";

export interface IMessagePayload {
    key: string;
    value: React.ReactNode;
}

export class MessagesActions extends ActionsHubBase {

    public static getKey(): string {
        return "environments-message-bar-actions";
    }

    public initialize(instanceId?: string): void {
        this._addMessage = new Action<IMessagePayload>();
        this._clearMessage = new Action<string>();
    }

    public get addMessage(): Action<IMessagePayload> {
        return this._addMessage;
    }

    public get clearMessage(): Action<string> {
        return this._clearMessage;
    }

    private _addMessage: Action<IMessagePayload>;
    private _clearMessage: Action<string>;
}
